import { render } from "./RgbaToHex.vue?vue&type=template&id=47250bfa&ts=true"
import script from "./RgbaToHex.vue?vue&type=script&lang=ts"
export * from "./RgbaToHex.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/ultrapixel/Downloads/Programmierung/github/vuejs/hex-to-rgba/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__